import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
@Injectable({ providedIn: 'root' })
export class PersonService extends BaseService {
  getPerson() {
    const url = `${environment.portalApi}/person/PersonCore`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  getPersonDependant() {
    const url = `${environment.portalApi}/PhysicalPerson/full/1`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  GetActualBankAccount() {
    const url = `${environment.portalApi}/Person/GetActualBankAccount`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  GetListaCaminhadas() {
    const url = `${environment.portalApi}/Person/ListCaminhadas`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  GetListUserNotifications() {
    const url = `${environment.portalApi}/Person/ListUserNotifications`;
    return this.http.get(url, { headers: this.createHeader() });
  }
}
